import { React, useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/Context";
import axios from "axios";

function ThemePicker() {
  const { baseUrl } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();
  const [formData, setFormData] = useState({
    selectedOption: "",
  });

  const [option, setOption] = useState([]);

  console.log(option);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  console.log(formData);
  const handleSubmit = async (e) => {
    try {
      const response = await axios.post(
        `${baseUrl}/admin_panel/user_themes/update.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          theme_id: parseInt(formData.selectedOption),
        }
      );
      const { data } = response;
      console.log(data);
    } catch (error) {
      if (error.response.status === 404) {
        // not found
      }
    }
    /*
    if (formData.selectedOption === "dos") {
      localStorage.setItem("idleClass", "dos-btn");
      localStorage.setItem("activeClass", "dos-btn-active");
    } else if (formData.selectedOption === "neo") {
      localStorage.setItem("idleClass", "neo-btn");
      localStorage.setItem("activeClass", "neo-btn-active");
    } else {
      console.error("Please select an option");
    }*/
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/admin_panel/themes/readThemes.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        const { data } = response;
        console.log(data);
        if (data.status === 200) {
          setOption(data.data);
        }
      } catch (error) {
        if (error.response.status === 404) {
          // not found
        }
      }
    };
    fetchData();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Select Class:
        <select
          name="selectedOption"
          value={formData.selectedOption}
          onChange={handleInputChange}
        >
          <option value="">Select...</option>
          {option.map((o) => {
            return <option value={o.theme_id}>{o.name}</option>;
          })}
        </select>
      </label>

      <button type="submit">Submit</button>
    </form>
  );
}

export default ThemePicker;
